import React from 'react';

function QueueImputs(props) {
  const { changeValues, tenants, moh, disableTimeout } = props;

  return (
    <div>
      <div className="form-row">
        <div className="form-field form-field-small">
          <label className="form-label">Cliente</label>
          <div className="form-control">
            <select className="form-select" name="accountcode" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              {tenants.map((tenant) => <option key={`${tenant.short_name}`} value={tenant.short_name}>{tenant.name}</option>)}
            </select>
            <p name="accountcode-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-large">
          <label className="form-label">Nome da Fila</label>
          <div className="form-control">
            <input className="form-input" name="name" type="text" onChange={(e) => changeValues(e.target)} placeholder="Nome" />
            <p name="name-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Música</label>
          <div className="form-control">
            <select className="form-select" name="music" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="default">Padrão</option>
              {moh.map((moh) => <option key={`${moh.name}`} value={moh.name}>{moh.name}</option>)}
            </select>
            <p name="music-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Descanso</label>
          <div className="form-control">
            <input className="form-input" name="wrapuptime" type="number" onChange={(e) => changeValues(e.target)} placeholder="3" />
            <p name="wrapuptime-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Segunda Chamada</label>
          <div className="form-control">
            <select className="form-select" name="ringinuse" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
            </select>
            <p name="ringinuse-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-field form-field-small">
          <label className="form-label">Anúncio Posição Fila</label>
          <div className="form-control">
            <select className="form-select" name="announcePosition" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
            </select>
            <p name="announcePosition-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-medium">
          <label className="form-label">Anún. Tempo Estimado</label>
          <div className="form-control">
            <select className="form-select" name="announceHoldTime" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
            </select>
            <p name="announceHoldTime-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Mínimo</label>
          <div className="form-control">
            <input className="form-input" name="minAnnounceFrequency" type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
            <p name="minAnnounceFrequency-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Freq.</label>
          <div className="form-control">
            <input className="form-input" name="announceFrequency" type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
            <p name="announceFrequency-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Entrar (Se Vazia)</label>
          <div className="form-control">
            <select className="form-select" name="joinempty" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
              <option value="strict">Restrito</option>
            </select>
            <p name="joinempty-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Sair (Se Vazia)</label>
          <div className="form-control">
            <select className="form-select" name="leavewhenempty" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
              <option value="strict">Restrito</option>
            </select>
            <p name="leavewhenempty-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-field form-field-medium">
          <label className="form-label">Estratégia</label>
          <div className="form-control">
            <select className="form-select" name="strategy" onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="ringall">Tocar Todos</option>
              <option value="linear">Linear</option>
              <option value="random">Aleatório</option>
              <option value="rrmemory">Crescente</option>
              <option value="leastrecent">Ocioso</option>
              <option value="fewestcalls">Estatística</option>
            </select>
            <p name="strategy-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-medium">
          <label className="form-label">Máximo de Chamadas</label>
          <div className="form-control">
            <input className="form-input" name="maxlen" type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
            <p name="maxlen-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-medium">
          <label className="form-label">Tempo de Transbordo</label>
          <div className="form-control">
            <input className="form-input" name="timeout" type="number" onChange={(e) => changeValues(e.target)} placeholder="35" disabled={disableTimeout} />
            <p name="timeout-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueueImputs;
